export default __webpack_public_path__ + "static/media/Tanya.35f6b410.jpg";